import Usanse from "./Usance";

const UsanceConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/usance',
      element: <Usanse />,
    },
    
  ],
};

export default UsanceConfig;
